import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import SurveyorModel from '../models/SurveyorModel';

interface surveyorInputState {
    SurveyorInput: SurveyorModel,
    selectedSurveyorId: string,
    SurveyorInputExpand: boolean,
    triggerFocusCompanyNameInput: number,
    triggerSave: number,
    triggerRefreshInput: number,
}

const initialState: surveyorInputState = {
    SurveyorInput: {
        id: "",
        name: "",
        country: "",
        contactDetailsAndCost: "",
        ports: [],
        remark: ""
    } as unknown as SurveyorModel,
    selectedSurveyorId: "",
    SurveyorInputExpand: true,
    triggerFocusCompanyNameInput: 0,
    triggerSave: 0,
    triggerRefreshInput: 0,
}

export const SurveyorInputSlice = createSlice({
    name: "SurveyorInput",
    initialState,
    reducers: {
        setSurveyorInputId: (state, action: PayloadAction<string>) => {
            state.SurveyorInput.id = action.payload;
        },
        setSurveyorInput: (state, action: PayloadAction<SurveyorModel>) => {
            state.SurveyorInput = action.payload;
        },
        setSurveyorName: (state, action: PayloadAction<string>) => {
            state.SurveyorInput.name = action.payload;
        },
        setCountry: (state, action: PayloadAction<string>) => {
            state.SurveyorInput.country = action.payload;
        },
        setContactDetailsAndCost: (state, action: PayloadAction<string>) => {
            state.SurveyorInput.contactDetailsAndCost = action.payload;
        },
        setPorts: (state, action: PayloadAction<number[]>) => {
            state.SurveyorInput.ports = action.payload;
        },
        setRemark: (state, action: PayloadAction<string>) => {
            state.SurveyorInput.remark = action.payload;
        },
        setSelectedSurveyorId: (state, action: PayloadAction<string>) => {
            state.selectedSurveyorId = action.payload;
        },
        setSurveyorInputExpand: (state, action: PayloadAction<boolean>) => {
            state.SurveyorInputExpand = action.payload;
        },
        setTriggerFocusCompanyNameInput: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyNameInput = action.payload;
        },
        resetSurveyorInput: (state) => {
            state.SurveyorInput = initialState.SurveyorInput;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
    }
});

export const SurveyorInputSelector = createSelector(
    (state: RootState) => state.surveyorInput,
    (data) => data
);

export const {
    setSurveyorInputId,
    setSurveyorInput,
    setSurveyorName,
    setCountry,
    setContactDetailsAndCost,
    setPorts,
    setRemark,
    setSelectedSurveyorId,
    setSurveyorInputExpand,
    setTriggerFocusCompanyNameInput,
    resetSurveyorInput,
    setTriggerSave,
    setTriggerRefreshInput,
} = SurveyorInputSlice.actions;

export default SurveyorInputSlice.reducer;